import { LegalConsentsReponse } from '../organisms/LegalConsents/__mock__/LegalConsents.mock';
import {
  ConsentsCheckboxesState,
  ConsentsSectionTypes,
  ConsentsState,
} from '../organisms/LegalConsents/ConsentsList/ConsentsList.types';
import {
  ConsentCheckbox,
  ConsentsMapped,
  ConsentSectionType,
  LegalConsent,
  // ConsentsSectionTypes,
  // LegalConsent,

  // LegalConsentsCheckboxState,
  // LegalConsentSectionType,
} from '../organisms/LegalConsents/LegalConsents.types';

// import { LegalConsent } from '../organisms/LegalConsents/LegalConsents.types';

// Returns true or false based in the input
export function isEmpty(value: unknown): boolean {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  if (typeof value === 'object' && Object.keys(value).length === 0) {
    return true;
  }
  return false;
}

// Works with array of objects
// Returns the object element of an array if matching KEY value and input matchValue is true
function getElementByArray<T, U extends keyof T>({
  data,
  key,
  matchValue,
}: {
  data: Array<T>;
  key: U;
  matchValue: string;
}): null | T {
  if (isEmpty(data)) {
    return null;
  }

  const dataLen = data.length;
  for (let i = 0; i < dataLen; i++) {
    const element = data[i];
    const value = element[key];
    if (value === matchValue) {
      return element;
    }
  }

  return null;
}

function toggleAllConsentsCheckboxes({
  consents,
  checkboxValue,
}: {
  consents: LegalConsent[];
  checkboxValue: boolean;
}): LegalConsent[] {
  // This loop throu all the consents inlcuding the agreeAll(privacy) consents
  // We don't need additional calls to toggle the agreeAll(privacy) consents checkboxes
  const consentLen = consents.length;
  for (let i = 0; i < consentLen; i++) {
    const consent = consents[i];
    const checkboxes = consent.checkboxes;
    const consentCheckboxesLen = checkboxes.length;

    // Looping through all the checkboxes
    for (let j = 0; j < consentCheckboxesLen; j++) {
      // ignoring the existing the checkbox state and overriding to checkboxValue
      checkboxes[j].checked = checkboxValue;
    }
  }

  return consents;
}

function toggleSelectedConsentCheckboxAlongWithAgreeAllConsentCheckbox({
  consents,
  selectedConsentCheckboxId,
}: {
  consents: LegalConsent[];
  selectedConsentCheckboxId: string;
}) {
  let agreeAllConsents = {} as LegalConsent;
  let togglledSelectedConsentCheckboxValue = null;
  let isAllCheckboxesChecked = true;
  const consentLen = consents.length;
  for (let i = 0; i < consentLen; i++) {
    const consent = consents[i];

    if (consent.sectionType === ConsentSectionType.AgreeToAll) {
      agreeAllConsents = consent;
      continue;
    }

    const checkboxes = consent.checkboxes;
    const consentCheckboxesLen = checkboxes.length;
    for (let j = 0; j < consentCheckboxesLen; j++) {
      if (checkboxes[j].id === selectedConsentCheckboxId) {
        togglledSelectedConsentCheckboxValue = checkboxes[j].checked ? false : true;
        checkboxes[j].checked = togglledSelectedConsentCheckboxValue;
      }

      if (checkboxes[j].checked === false) {
        isAllCheckboxesChecked = false;
      }
    }
  }

  agreeAllConsents.checkboxes[0].checked = isAllCheckboxesChecked ? true : false;
  return consents;
}

export function toggleSelectedConsentCheckbox({
  consents,
  selectedConsentId,
  isAgreeAllConsentsInTheList = false,
}: {
  consents: LegalConsent[];
  selectedConsentId: string;
  isAgreeAllConsentsInTheList?: boolean;
}): LegalConsent[] {
  const [selectedConsentsSectioonType] = selectedConsentId.split('-');
  const selectedConsent = getElementByArray({
    data: consents,
    key: 'sectionType',
    matchValue: selectedConsentsSectioonType,
  });

  // TODO: Throw specifc error code or error message here
  if (!selectedConsent) {
    return [] as LegalConsent[];
  }

  // If the section is privacy consent (agree to all the consents)
  // Then assign the checkboxVaue to all the consents checkboxes
  if (selectedConsentsSectioonType === 'agreeAll') {
    const selectedConsent = getElementByArray({
      data: consents,
      key: 'sectionType',
      matchValue: selectedConsentsSectioonType,
    }) as LegalConsent;
    const selectedConsentCheckbox = selectedConsent.checkboxes[0];
    const toggledSelectedConsentCheckboxValue = selectedConsentCheckbox.checked ? false : true;

    // This loop throu all the consents inlcuding the agreeAll(privacy) consents
    // We don't need additional calls to toggle the agreeAll(privacy) consents checkboxes
    return toggleAllConsentsCheckboxes({ consents, checkboxValue: toggledSelectedConsentCheckboxValue });
  }

  const selectedConsentCheckbox = getElementByArray({
    data: selectedConsent.checkboxes,
    key: 'id',
    matchValue: selectedConsentId,
  });

  // TODO: Throw specifc error code or error message here
  if (!selectedConsentCheckbox) {
    return [] as LegalConsent[];
  }

  if (isAgreeAllConsentsInTheList === false) {
    const toggledSelectedConsentCheckboxValue = selectedConsentCheckbox.checked ? false : true;
    selectedConsentCheckbox.checked = toggledSelectedConsentCheckboxValue;

    return consents;
  }

  return toggleSelectedConsentCheckboxAlongWithAgreeAllConsentCheckbox({
    consents,
    selectedConsentCheckboxId: selectedConsentId,
  });
}

function sortArrayByField<T, U extends keyof T>({ data, sortField }: { data: Array<T>; sortField: U }) {
  data = data?.sort((a, b) => {
    if (a[sortField] < b[sortField]) {
      return -1;
    }
    if (a[sortField] > b[sortField]) {
      return 1;
    }
    return 0;
  });

  return data;
}

function getApplicableAndSortedConsentsCheckboxes({
  checkboxes,
  sectionType,
  countryCode,
  option,
  sortEntries = false,
}: {
  checkboxes: ConsentCheckbox[];
  sectionType: ConsentSectionType;
  countryCode: string;
  option: string;
  sortEntries?: boolean;
}) {
  const consentState: ConsentsCheckboxesState = {};
  let filteredCheckboxes: ConsentCheckbox[] = [];
  const checkboxesLen = checkboxes.length;
  for (let j = 0; j < checkboxesLen; j++) {
    const checkbox = checkboxes[j];
    const { forCountries, excludeCountries, forOptions, excludeOptions } = checkbox;

    // If forCountries field does not exists or empty
    // Then considering that by default it is applied for all the country code that are tagged at the consent section level
    // If forCountries has the values and it does not match with the current country code then we have to skip this checkbox entry
    const isCurrentCountryInTheForCountryList =
      !isEmpty(forCountries) && (forCountries as string[]).indexOf(countryCode) === -1 ? false : true;
    console.log('isCurrentCountryInTheForCountryList', !isEmpty(forCountries));

    // If forOptions field does not exists or empty
    // Then considering that by default it is applied for all the options that are tagged at the consent section level
    // If forOptions has the values and it does not match with the current country code then we have to skip this checkbox entry
    const isCurrentOptionInTheForOptionsList =
      !isEmpty(forOptions) && (forOptions as string[]).indexOf(option) === -1 ? false : true;

    const isExcludeCurrentCountryList = excludeCountries?.indexOf(countryCode) !== -1 ? true : false;
    const isExcludeCurrentOptionList = excludeOptions?.indexOf(option) !== -1 ? true : false;

    const isForConditonValid = isCurrentCountryInTheForCountryList && isCurrentOptionInTheForOptionsList;
    const isExcludeConditonValid = isExcludeCurrentCountryList || isExcludeCurrentOptionList;

    if (!isForConditonValid || isExcludeConditonValid) {
      continue;
    }

    // TODO:: Validate for name and thorw error if name is not available
    checkbox.id = `${sectionType}-${checkbox.name}`;
    const isChecked = checkbox.defaultChecked ? true : false;
    consentState[checkbox.id] = isChecked;
    checkbox.checked = isChecked;
    filteredCheckboxes.push({ ...checkbox });
  }

  if (sortEntries && filteredCheckboxes.length > 1) {
    filteredCheckboxes = sortArrayByField({ data: filteredCheckboxes, sortField: 'index' });
  }

  return { filteredCheckboxes, consentState };
}

export function getApplicableAndSortedConsents({
  allConsents,
  countryCode,
  option,
}: {
  allConsents: LegalConsent[];
  countryCode: string;
  option: string;
}): ConsentsState {
  const allConsentsLen = allConsents.length;
  const consentsMapped: ConsentsMapped = {};
  let consents: LegalConsent[] = [];
  const consentsSectionTypes: ConsentsSectionTypes = {};
  let consentStateContainer = {};
  for (let i = 0; i < allConsentsLen; i++) {
    const consent = allConsents[i];
    if (isEmpty(consent)) {
      continue;
    }
    console.log('sortedConsentListData-consent', consent.checkboxes);
    const { countries, options, checkboxes } = consent;
    const isCountryMatched = countries.indexOf(countryCode) !== -1;
    const isOptionMatched = options.indexOf(option) !== -1;
    if (isCountryMatched && isOptionMatched) {
      console.log('sortedConsentListData-consent-matched', consent.sectionType);
      consentsSectionTypes[consent.sectionType] = consent.sectionType;
      const { filteredCheckboxes, consentState } = getApplicableAndSortedConsentsCheckboxes({
        checkboxes,
        countryCode,
        sectionType: consent.sectionType,
        option,
        sortEntries: true,
      });

      consentStateContainer = { ...consentStateContainer, ...consentState };
      console.log('sortedConsentListData-consent-state', filteredCheckboxes);
      const newConsent: LegalConsent = { ...consent, checkboxes: filteredCheckboxes };

      const mappedConsent = consentsMapped[newConsent.sectionType];
      console.log('sortedConsentListData-consent-state-mapped', newConsent);
      const isSectionTypeEntryExists = mappedConsent ? true : false;
      if (isSectionTypeEntryExists) {
        mappedConsent.push(newConsent);
        consentsMapped[newConsent.sectionType] = mappedConsent;
      } else {
        consentsMapped[newConsent.sectionType] = [newConsent];
      }

      consents.push(newConsent);
      consents = sortArrayByField({ data: consents, sortField: 'index' });
    }
  }

  return { list: consents, sectionTypes: consentsSectionTypes, checkboxesState: consentStateContainer };
}

export async function getLegalConsents({ local }: { local: string }) {
  console.log('getLegalConsents ', local);
  return LegalConsentsReponse;
}
